export default [
    {
        key: 'display',
        components: [
            {
                key: 'labelPosition',
                ignore: true,
            },
            {
                key: 'placeholder',
                ignore: true,
            },
            {
                key: 'disabled',
                ignore: true,
            },
            {
                key: 'tableView',
                ignore: true,
            },
            {
                key: 'modalEdit',
                ignore: true,
            },
            {
                key: 'label',
                label: 'Frequency & Amounts label',
                tooltip: 'Set the label for the frequency and amount options',
                defaultValue: 'Frequency and amounts',
            },
            {
                type: 'textfield',
                label: 'Frequencies label',
                key: 'frequencies_label',
                tooltip: 'Set the label for the frequencies options',
                input: true,
                allowCalculateOverride: false,
                defaultValue: 'I support...',
                weight: 30,
            },
            {
                type: 'textfield',
                label: 'Amounts label',
                key: 'amounts_label',
                tooltip: 'Set the label for the amounts options',
                input: true,
                allowCalculateOverride: false,
                defaultValue: 'I give...',
                weight: 31,
            },
            {
                type: 'textfield',
                label: 'Amount `other` label',
                key: 'min_amount_other_label',
                tooltip: 'Set the label for amount `other`',
                input: true,
                allowCalculateOverride: false,
                defaultValue: 'Other',
                weight: 32,
            },
            {
                key: 'default_frequency',
                type: 'select',
                label: 'Default frequency',
                tooltip: 'Set the default frequency. Only frequencies with amounts are active',
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                weight: 33,
                data: {
                    custom: function custom(ctx) {
                        var frequencies = [];
                        ['once', 'monthly', 'quarterly', 'yearly'].forEach(function (freq) {
                            var freqAmounts = ctx.data["amounts_" + freq];
                            for (var i = 0; i < Object.keys(freqAmounts).length; i++) {
                                if (freqAmounts[i].label !== '' && freqAmounts[i].value !== '') {
                                    frequencies.push({
                                        value: freq,
                                        label: freq
                                    });
                                    break;
                                }
                            }
                        });
                        return frequencies;
                    }
                },
                validate: {
                    required: true
                }
            },
            {
                type: 'textfield',
                label: 'Amount `other` input label',
                key: 'min_amount_other_input_label',
                tooltip: 'Set the label for amount `other` input',
                input: true,
                allowCalculateOverride: false,
                defaultValue: '€',
                weight: 34,
            },
            {
                type: 'textfield',
                label: 'Amount `other` input placeholder',
                key: 'min_amount_other_input_placeholder',
                tooltip: 'Set the placeholder for amount `other` input',
                input: true,
                allowCalculateOverride: false,
                defaultValue: 'Other',
                weight: 35,
            },
        ]
    },
];
